<template>
  <div class="modal-container row h-100">

    <slot/>

    <div class="swiper-container col-lg-8 col-md-7 col-sm-6 col-xs-12 h-100" ref="mainSwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(doc, i) in documents" :key="i">
          <template v-if="doc.mediaType === 'iframe'">
            <iframe :src="doc.src" class="pdf-frame"></iframe>
          </template>
          <template v-else>
            <img :src="doc.src" class="main-image" />
          </template>
        </div>
      </div>

      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>

      <div class="thumbnails">
        <img
          v-for="(img, i) in documents"
          :key="i"
          :src="img.thumb"
          :class="{ active: i === activeIndex }"
          @click="goToSlide(i)"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/swiper.scss';

export default {
  props: ['documents', 'selected'],
  data() {
    return {
      mainSwiper: null,
      activeIndex: 0
    };
  },
  mounted() {
    this.activeIndex = this.selected ?? 0
    if (this.mainSwiper === null) {
      this.mainSwiper = new Swiper(this.$refs.mainSwiper, {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        initialSlide: this.selected
      })

      this.mainSwiper.on('slideChange', () => {
        this.activeIndex = this.mainSwiper.activeIndex;
      });
    }
    this.mainSwiper.slideTo(this.selected);
  },
  beforeDestroy() {
    if (this.mainSwiper) {
      this.mainSwiper.destroy(true, true);
      this.mainSwiper = null;
    }
  },

  methods: {
    goToSlide(index) {
      if (this.mainSwiper) {
        this.mainSwiper.update()

        this.mainSwiper.slideTo(index);
      }
    }
  }
};
</script>

<style>
.h-100 {
  height: 100%;
}
.main-image {
  width: 100%;
  height: auto;
}

.thumbnails {
  display: flex;
  margin-top: 10px;
}

.thumbnails img {
  width: 60px;
  height: 60px;
  margin-right: 5px;
  cursor: pointer;
  border: 2px solid transparent;
}

.thumbnails img.active {
  border-color: blue;
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.pdf-frame {
  width: 100%;
  height: 100%;
}

</style>
